"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var GroupSpacer_1 = require("./GroupSpacer");
var stylesImport = require("./GroupFooter.scss");
var styles = stylesImport;
var GroupFooter = /** @class */ (function (_super) {
    tslib_1.__extends(GroupFooter, _super);
    function GroupFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupFooter.prototype.render = function () {
        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, footerText = _a.footerText;
        if (group && footerText) {
            return (React.createElement("div", { className: Utilities_1.css('ms-groupFooter', styles.root) },
                GroupSpacer_1.GroupSpacer({ count: groupLevel }),
                footerText));
        }
        return null;
    };
    return GroupFooter;
}(Utilities_1.BaseComponent));
exports.GroupFooter = GroupFooter;
//# sourceMappingURL=GroupFooter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/GroupedList/GroupFooter.js
// module id = 1560
// module chunks = 0